/** Studio › Organisation leaves (design/os-reorganisation-ecrans § 3). */
export const ORG_ROUTES = {
  models: '/studio/llm',
  accessMap: '/studio/access-map',
  gates: '/studio/gates',
  members: '/studio/members',
  vault: '/studio/vault',
  usage: '/studio/usage',
  importExport: '/studio/import-export',
} as const

/** Organisation-level paths: they never reveal an Agent's settings group. */
export const ORG_ROUTE_PATHS: string[] = Object.values(ORG_ROUTES)

/** Machine gates tab that is the home of the approval mandates (AGENT-849). */
export const APPROVAL_MANDATES_SECTION = 'mandates'

/** Machine gates tab that is the home of the members' node mandates that target the organization (AGENT-861). */
export const NODE_MANDATES_SECTION = 'node-mandates'

export const MY_ACCESS_ROUTE = '/run/my-access'

/** Run › Applications › App › Spaces: the single Run entry for spaces (lot R4). */
export const RUN_SPACES_ROUTE = '/run/spaces'

/** Agent-scoped LLM roles, split from the org catalogue (OS-21). */
export const AGENT_MODELS_ROUTE = '/studio/agent-models'

export function orgLeafHref(
  path: string,
  organizationId: string | null | undefined,
  extra?: Record<string, string>,
): string {
  const params = new URLSearchParams()
  if (organizationId) params.set('organizationId', organizationId)
  for (const [key, value] of Object.entries(extra ?? {})) params.set(key, value)
  const search = params.toString()
  return search ? `${path}?${search}` : path
}
